








































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useUserStore } from "@/shared/store/user";
import { ConsumerClaimsExchangeSettingsResponse, FetchState } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    Widget,
    GenericLoadingSpinner,
  }
})
export default class HsabConsumerClaimsExchangeSettings extends Vue {
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  mounted () {
   this.userStore.loadConsumerClaimExchangeSettings();
  }
  get showLoadingPage () {
    return this.userStore.consumerClaimsExchangeSettingsState !== FetchState.Loaded;
  }

  get claimsExchangeSettings (): ConsumerClaimsExchangeSettingsResponse | any {
    return this.userStore.consumerClaimsExchangeSettings !== null ? this.userStore.consumerClaimsExchangeSettings : {};
  }

  get showAutoEnrollHsa (): boolean {
    return this.claimsExchangeSettings.isAutoClaimSync && this.hsabAccountsStore.userHasHsaAccount;
  }
  get showAutoFileClaim (): boolean {
    return this.claimsExchangeSettings.isAutoClaimSync && this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }
}
